import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

const rootEl = document.getElementById("espace-client-root");
if (!rootEl) throw new Error("Root element #espace-client-root not found");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>
);
